import {makeStyles} from '@material-ui/core/styles';
import {Fonts, ThemeMode} from '../../../../shared/constants/AppEnums';
import {CremaTheme} from '../../../../types/AppContextPropsType';

const useStyles = makeStyles((theme: CremaTheme) => {
  return {
    navItem: {
      height: 40,
      marginTop: 2,
      marginBottom: 2,
      cursor: 'pointer',
      textDecoration: 'none !important',
      width: 'calc(100% - 16px)',
      borderRadius: '0 30px 30px 0',
      paddingLeft:
        theme.direction === 'ltr'
          ? (props: {level: number; themeMode: ThemeMode}) =>
              24 + 40 * props.level
          : 12,
      paddingRight:
        theme.direction === 'rtl'
          ? (props: {level: number; themeMode: ThemeMode}) =>
              24 + 40 * props.level
          : 12,
      '&.nav-item-header': {
        textTransform: 'uppercase',
      },
      '&.active': {
        backgroundColor: theme.palette.primary.main,
        pointerEvents: 'none',
        transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
        '& .nav-item-text': {
          color: theme.palette.primary.main,
          fontWeight: Fonts.MEDIUM,
        },
        '& .nav-item-icon': {
          color: theme.palette.primary.main
        },
      },
      '&.active-custom': {
        // backgroundColor: theme.palette.primary.main,
        // pointerEvents: 'none',
        transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
        '& .nav-item-text': {
          color: theme.palette.secondary.main,
          fontWeight: Fonts.BOLD,
        },
        '& .nav-item-icon': {
          color: theme.palette.secondary.main
        },
      },
      '&.Role': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        pointerEvents: 'none',
        '& .nav-item-text': {
          color: `${theme.palette.primary.main} !important`,
          fontWeight: Fonts.BOLD,
        },
        '& .nav-item-icon': {
          fontSize: 24,
          marginTop: 5,
          color: `${theme.palette.primary.main} !important`,
        },
      },

      '&:hover, &:focus': {
        '& .nav-item-text': {
          color: theme.palette.primary.main
        },

        '& .nav-item-icon': {
          color: theme.palette.primary.main
        },

        '& .nav-item-icon-arrow': {
          color: theme.palette.primary.main
        },
      },
      '& .nav-item-icon': {
        color: theme.palette.sidebar.textColor,
      },
      '& .nav-item-text': {
        color: theme.palette.sidebar.textColor,
        fontWeight: Fonts.MEDIUM,
      },
    },
    listIcon: {
      fontSize: 18,
      [theme.breakpoints.up('xl')]: {
        // fontSize: 20,
      },
    },
    listItemText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontWeight: Fonts.REGULAR,
    },
  };
});
export default useStyles;
